import { render } from "./MyRebates.vue?vue&type=template&id=1df0c57d"
import script from "./MyRebates.vue?vue&type=script&lang=ts"
export * from "./MyRebates.vue?vue&type=script&lang=ts"
script.render = render

export default script